import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const initialFormData = {
  categoryname: "",
  fir_no: "",
  filing_date: new Date().toISOString().split('T')[0], // Default to today's date in YYYY-MM-DD format
  description: "",
  status: true,
  isPrimary: false,
};

const FirDialog = ({ open, onClose, onSave, selectedFir }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  console.log("Selected FIR in FirDialog:", selectedFir);

  // Input change handler + Live validation cleanup
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error for the field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Form Validation Logic
  const validateForm = () => {
    let tempErrors = {};

    // if (!formData.categoryname.trim()) {
    //   tempErrors.categoryname = "FIR Name is required";
    // }
    if (!formData.fir_no.trim()) {
      tempErrors.fir_no = "FIR No is required";
    }
    if (!formData.filing_date) {
      tempErrors.filing_date = "Filing Date is required";
    }
    // if (!formData.description.trim()) {
    //   tempErrors.description = "IPC Section / Description is required";
    // }

    setErrors(tempErrors);

    // Form valid tabhi hoga jab `tempErrors` me koi keys na hon
    return Object.keys(tempErrors).length === 0;
  };

  const handleSave = () => {
    // Check validation before saving
    if (!validateForm()) return;

    if (onSave) {
      onSave(formData);
    }

    handleResetAndClose();
  };

  const handleResetAndClose = () => {
    setFormData(initialFormData);
    setErrors({});
    onClose();
  };

  useEffect(() => {
    if (selectedFir) {
      setFormData((prev) => ({
        ...prev,
        fir_no: selectedFir || "",
      }));
    }
  }, [selectedFir]);

  return (
    <Dialog
      open={open}
      onClose={handleResetAndClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Add FIR Details</DialogTitle>

      <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
          <Grid item xs={12}>
            <Typography variant="h6" component="h2" sx={{ fontSize: { xs: 16, sm: 18 } }}>
              FIR Details
            </Typography>
          </Grid>


          {/* FIR No */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="FIR No *"
              name="fir_no"
              value={formData.fir_no}
              onChange={handleChange}
              error={Boolean(errors.fir_no)}
              helperText={errors.fir_no}
            />
          </Grid>

          {/* Filing Date */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              type="date"
              label="Filing Date *"
              name="filing_date"
              value={formData.filing_date}
              onChange={handleChange}
              error={Boolean(errors.filing_date)}
              helperText={errors.filing_date}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* FIR Name */}
          <Grid item xs={12} sm={6} md={8}>
            <TextField
              fullWidth
              size="small"
              label="FIR Summary *"
              name="categoryname"
              value={formData.categoryname}
              onChange={handleChange}
              // error={Boolean(errors.categoryname)}
              // helperText={errors.categoryname}
              multiline
              rows={4}
            />
          </Grid>

          {/* IPC Section */}
          {/* <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              label="IPC Section *"
              name="description"
              value={formData.description}
              onChange={handleChange}
              //   error={Boolean(errors.description)}
              //   helperText={errors.description}
              multiline
              rows={2}
            />
          </Grid> */}

          {/* Checkboxes */}
          <Grid item xs={12}>
            <FormGroup row sx={{ gap: { xs: 1, sm: 3 } }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.status}
                    onChange={handleCheckboxChange}
                    name="status"
                  />
                }
                label="Status"
              />

              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.isPrimary}
                    onChange={handleCheckboxChange}
                    name="isPrimary"
                  />
                }
                label="Is Primary"
              /> */}
            </FormGroup>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: { xs: 2, sm: 2 } }}>
        <Button onClick={handleResetAndClose} color="inherit">
          Cancel
        </Button>

        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FirDialog;